import scssVariables from "../resources/style/exports.scss"

export const animationDuration = parseFloat(scssVariables.animationduration ?? "0.3") * 1000
export const footerHeight = parseInt(scssVariables.footerheight ?? "88")
export const footerPaddingBottom = parseInt(scssVariables.footerpaddingbottom ?? "20")
